module.exports = __webpack_public_path__ + "static/media/image7.eb9d67fd.png";